import cloudinary from 'cloudinary-core'

export const cloudinaryCore = new cloudinary.Cloudinary({
  cloud_name: 'knowyourmome',
})

export const TAG = process.env.NODE_ENV === 'development' ? 'mome-dev' : 'mome'

export default cloudinaryCore
